import { Numbers } from 'venn-utils';
import type { BenchmarkShape } from '../../types';

export function computeTotalWeight(benchmarks: BenchmarkShape[]) {
  return benchmarks.reduce((totalWeight: number, { weight }) => totalWeight + (Number(weight) || 0), 0);
}

export const formatTotalWeight = (totalWeight: number) => Numbers.formatNumber(totalWeight, 1);
